/* eslint-disable react/no-unused-state */
/* eslint-disable react/no-array-index-key */

import React from 'react'
import PropTypes from 'prop-types'
import { NavLink } from 'react-router-dom'
import { Container } from 'components/layout/Grid/'
import ActionButton from 'components/ActionButton'
import styles from './Banner.scss'
import BannerSelect from 'components/BannerSelect'
import { IconDownArrow } from 'icons'

class Banner extends React.Component {
  static propTypes = {
    routes: PropTypes.array,
    history: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    defaultBack: PropTypes.string,
    bannerSelectProps: PropTypes.object,
    name: PropTypes.string,
    actionButton: PropTypes.object,
  }

  static defaultProps = {
    defaultBack: null,
    bannerSelectProps: null,
    name: '',
    actionButton: null,
    routes: [],
  }

  constructor(props) {
    super(props)

    this.state = {
      index: 0,
    }
  }

  componentWillMount() {
    const { routes } = this.props
    if (routes && routes.length > 0) { this.checkRouteValidity(this.props) }
  }

  componentWillReceiveProps(nextProps) {
    const { routes } = nextProps
    if (routes && routes.length > 0 &&
      nextProps.location.pathname !== this.props.location.pathname
    ) { this.checkRouteValidity(nextProps) }
  }

  goBack = () => {
    if (this.props.history.length > 1) {
      this.props.history.goBack()
    } else {
      if (this.props.defaultBack !== null) {
        this.props.history.push(this.props.defaultBack)
      }
    }
  }

  checkRouteValidity(props) {
    const { location: { pathname }, routes, match } = props
    if (pathname === match.url || (`${pathname}/`) === match.url) {
      if (this.props.location.pathname.startsWith(props.location.pathname)) {
        this.handleTabChange(this.state.index, props)
      }
    } else {
      routes.forEach((route, index) => {
        if (pathname === route.path) {
          if (this.state !== index) {
            this.handleTabChange(index, props)
          }
        }
      })
    }
  }

  handleTabChange = (index, props) => {
    const { routes, history, location } = props
    const newRoutePath = routes[index].path
    this.setState({ index })

    if (location.pathname !== routes[index].path) {
      history.push(newRoutePath)
    }
  }

  render() {
    const {
      name, actionButton, routes = [], bannerSelectProps, defaultBack, history,
    } = this.props

    const navItems = routes.map(({ path = '#', name: itemName }, key) => {
      return (
        <NavLink activeClassName={styles.isActive} className={styles.navItem} key={key} to={path}>
          {itemName}
        </NavLink>
      )
    })

    const bannerTitle = (() => {
      if (name && !bannerSelectProps) {
        return <h1>{name}</h1>
      } else if (bannerSelectProps) {
        bannerSelectProps.history = history
        return <BannerSelect {...bannerSelectProps} />
      }
      return null
    })()

    return (
      <div className={styles.base}>
        <Container className={styles.container}>
          {
            (defaultBack && history.length) &&
            <a className={styles.back} onClick={this.goBack}>
              <IconDownArrow className={styles.icon} size="24" />
            </a>
          }
          {bannerTitle}
          { navItems.length > 0 && <nav className={styles.navItemList}>{navItems}</nav> }
          { actionButton && <ActionButton handleAction={actionButton.handleAction} tooltip={actionButton.tooltip} /> }
        </Container>
      </div>
    )
  }
}

export default Banner



// WEBPACK FOOTER //
// ./src/components/Banner/Banner.js